import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Smart Code Junction Infinity Private Limited Logo",
      width: "130px",
    },
    showPoweredBy: false,
    title: "Legal & Policies - Smart Code Junction Infinity Private Limited",
    footer: {
      position: "center",
      copyright: `© ${new Date().getFullYear()} Smart Code Junction Infinity Private Limited | CIN: U62099UP2025PTC230480 | All rights reserved.`,
      logo: {
        src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
        alt: "Smart Code Junction Infinity Private Limited Logo",
        width: "130px",
      },
    },
  },
  metadata: {
    favicon: "/favicon.ico",
    applicationName: "Smart Code Junction Infinity",
    creator: "Smart Code Junction Infinity",
    authors: [
      "Smart Code Junction Infinity"
    ],
    publisher: "Smart Code Junction Infinity",
    title: "",
  },
  navigation: [
    {
      type: "category",
      label: "WhatsDiscuss",
      items: [
        "/whatsdiscuss/privacy-policy",
        "/whatsdiscuss/terms-and-conditions",
      ],
    },
    {
      type: "category",
      label: "SmartAcademy",
      items: [
        "/smartacademy/privacy-policy",
        "/smartacademy/terms-and-conditions",
      ],
    },
    {
      type: "category",
      label: "SmartCarePlus",
      items: [
        "/smartcareplus/privacy-policy",
        "/smartcareplus/terms-and-conditions",
        "/smartcareplus/security-policy",
        "/smartcareplus/onboarding-policy",
        "/smartcareplus/cookie-policy",
        "/smartcareplus/medical-disclaimer",
      ],
    },
    {
      type: "category",
      label: "SmartFace Attendance",
      items: [
        "/smartface-attendance/privacy-policy",
        "/smartface-attendance/terms-of-service",
        "/smartface-attendance/data-retention-policy",
      ],
    },
  ],
  redirects: [
    { from: "/", to: "/introduction" },
  ],
  docs: {
    defaultOptions: {
      disablePager: false,
      toc: false,
      showLastModified: true,
    },
  },
};

export default config;
